var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TdMarkdownComponent } from './markdown.component';
var CovalentMarkdownModule = (function () {
    function CovalentMarkdownModule() {
    }
    return CovalentMarkdownModule;
}());
CovalentMarkdownModule = __decorate([
    NgModule({
        imports: [
            CommonModule,
        ],
        declarations: [
            TdMarkdownComponent,
        ],
        exports: [
            TdMarkdownComponent,
        ],
    })
], CovalentMarkdownModule);
export { CovalentMarkdownModule };
//# sourceMappingURL=markdown.module.js.map


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@covalent/markdown/markdown.module.js
// module id = ../../../../@covalent/markdown/markdown.module.js
// module chunks = 4